import "react";
import { jsx, jsxs } from "react/jsx-runtime";
// src/icons/bitcart-logo.svg?react
const SvgBitcartLogo = (props) => /* @__PURE__ */ jsxs("svg", {
	id: "Layer_2",
	"data-name": "Layer 2",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 598.49 531.33",
	...props,
	children: [/* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("style", { children: "\n      .cls-1 {\n        fill: currentColor;\n      }\n    " }) }), /* @__PURE__ */ jsx("g", {
		id: "Layer_1-2",
		"data-name": "Layer 1",
		children: /* @__PURE__ */ jsxs("g", { children: [
			/* @__PURE__ */ jsx("path", {
				className: "cls-1",
				d: "m563.86,225.52c-16.2,0-29.94,11.32-33.7,27.07-15.76,65.98-87.98,115.98-174.44,115.98-97.94,0-177.63-64.17-177.63-143.05v-63.53c0-79.26-64.25-143.51-143.51-143.51h0C15.49,18.48,0,33.96,0,53.06s15.49,34.59,34.59,34.59h3.3c39.23,0,71.03,31.8,71.03,71.03v66.83c0,117.02,110.72,212.23,246.81,212.23,119.13,0,218.81-72.95,241.81-169.63,5.17-21.72-11.34-42.6-33.68-42.6Z"
			}),
			/* @__PURE__ */ jsx("path", {
				className: "cls-1",
				d: "m240,433.11c-27.12,0-49.11,21.99-49.11,49.11s21.99,49.11,49.11,49.11,49.11-21.99,49.11-49.11-21.99-49.11-49.11-49.11Z"
			}),
			/* @__PURE__ */ jsx("circle", {
				className: "cls-1",
				cx: 478.28,
				cy: 482.22,
				r: 49.11,
				transform: "translate(-71.07 82.84) rotate(-9.22)"
			}),
			/* @__PURE__ */ jsx("path", {
				className: "cls-1",
				d: "m322.4,295.08c6.3,1.78,10.64,7.52,10.64,14.07v.08c0,11.29,9.15,20.44,20.44,20.44h15.54c11.29,0,20.44-9.15,20.44-20.44v-1.36c0-6.38,4.13-12.03,10.22-13.94,54.84-17.24,94.78-68.64,94.78-129.13s-39.93-111.89-94.78-129.13c-6.09-1.91-10.22-7.56-10.22-13.94v-1.29c0-11.29-9.15-20.44-20.44-20.44h-15.54c-11.29,0-20.44,9.15-20.44,20.44,0,6.55-4.34,12.29-10.64,14.07-56.83,16.01-98.58,68.37-98.58,130.29s41.75,114.28,98.58,130.29Zm36.7-196.47c35.25,0,64.12,27.65,66.07,62.42,2.05,36.51-27.39,68.74-63.93,69.91-37.41,1.19-68.24-28.92-68.24-66.15s29.67-66.18,66.1-66.18Z"
			})
		] })
	})]
});
export { SvgBitcartLogo as default };

//# sourceMappingURL=bitcart-logo.js.map